
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FFF","stroke":"#FFBE1B","stroke-width":"5.346","stroke-miterlimit":"10","d":"M2.29 2.29l35.42 35.42M37.71 2.29L2.29 37.71"}})])
          )
        }
      }
    